import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentCancelled: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/dashboard');
        }, 5000); // Redirect after a short delay

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            backgroundColor: '#2c2c2c',
            color: '#e0e0e0',
            textAlign: 'center'
        }}>
            <h1 style={{ color: '#FF7043', fontSize: '3em' }}>Payment not completed</h1>
            <p style={{ fontSize: '1.2em' }}>
                The payment was cancelled or did not go through. Please try again or choose another payment method.
            </p>
            <p style={{ marginTop: '20px' }}>You will be redirected to the dashboard in a few seconds...</p>
        </div>
    );
};

export default PaymentCancelled;
